export const eModeCategoryIdToName = {
  0: 'No E-Mode',
  1: 'ETH Correlated',
  2: 'Stablecoins',
} as const
